<template>
  <input class="p-inputtext p-component" ref="autocompleteInput" />
</template>

<script>
/* eslint-disable no-undef */
import { ref, onMounted } from "vue";
import { Loader } from "@googlemaps/js-api-loader";
export default {
  emits: ["place-changed"],
  setup(_props, context) {
    const GOOGLE_MAPS_API_KEY = "AIzaSyCB5IZDRWvwHXfz6P6Zij1kaFLDspuKMQk";
    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      libraries: ["places"]
    });
    const autocompleteInput = ref(null);
    const autocomplete = ref(null);
    const options = {
      componentRestrictions: { country: "fr" },
      fields: ["address_components", "formatted_address", "geometry", "url"]
    };
    onMounted(async () => {
      await loader.load();
      autocomplete.value = new google.maps.places.Autocomplete(
        autocompleteInput.value,
        options
      );

      autocomplete.value.addListener("place_changed", () => {
        const place = autocomplete.value.getPlace();
        context.emit("place-changed", place);
      });
    });

    return { autocompleteInput };
  }
};
</script>
